export default {
  finance: {
    purchaseInvoices: 'Purchase invoices',
    FVZ: 'FVZ',
    readyForInvoices: 'Ready for invoices',
    corrected: 'Corrected',
    accountToInvoice: 'Account to invoice',
    lastModification: 'Last modification of position links',
    imports: 'Imports',
    googleImport: 'Google purchase invoice import',
    googleImportDesc:
      'Import purchase invoices based on a file from Google and a directory with invoice prints',
    generalImport: 'Purchase invoice import',
    generalImportDesc:
      'Import purchase invoices from Excel file (general format)',
    importFvz: 'Purchase invoices (FVZ) Import',
    invoice: 'Invoice',
    fileNotFound: 'File not found',
    finishDownload: 'Data download completed.',
    importSuccessCount:
      'Successfully imported: {{success}} of {{total}} invoices.',
    importProblematicInvoices: 'Invoices, that were not imported:',
    userInCompanyContext:
      'The user must be in the context of the company where purchase invoices will be received',
    assumptions: 'Assumptions',
    assumption1: 'The first row in the Excel file contains the header row',
    assumptionColumnOrder: 'IMPORTANT! - Column order matters.',
    assumptionGeneral:
      'The first row in the Excel file contains the header row: File number, Currency, Issue date, Sale date, Payment date, Corrected invoice number, Corrected invoice issue date, Invoice amount, Campaign numbers, VAT rate, TV, Teams names, Comment. Column order matters.',
    assumption2:
      'If the contractor’s country is Poland, invoices are imported as domestic; otherwise, as foreign',
    assumption3: 'The amount column must be recognized as a number by Excel',
    assumption4: 'Three date columns should be recognized as dates by Excel',
    assumptionTv: 'The TV column should be true/false',
    assumptionProjectsNumber:
      'Campaign numbers can be listed separated by commas',
    assumptionTeamsNames: 'Team names can be listed separated by commas',
    client: 'Biller (contractor)',
    excelWithGoogleInvoices: 'Excel file containing data on Google invoices',
    excelWithGeneralInvoices: 'Excel file containing invoice data',
    directoryWithGoogleInvoices:
      'Directory containing invoices issued by Google',
    directoryWithGeneralInvoices: 'Directory containing invoices',
    chooseDirectory: 'Choose directory',
    errorSelectData:
      'Please specify the biller, an Excel file with data, and a directory with attachments.',
    import: 'Import',
    askImport: 'Are you sure you want to import the invoices?',
    dataDownload: 'Downloading data. Please wait...',
    archive: 'ARCHIVE',
    newFvz: 'New purchase invoice',
    fvz: 'Purchase invoice',
    correctingFvz: 'Correcting purchase invoice',
    correctedTo: 'to invoice no.',
    correctionToInvoice: 'Correction to invoice',
    for: 'for',
    packageWithNumber: 'in package no.',
    revertFromSent: 'Reverted from sent state',
    tvInvoice: 'TV invoice',
    purchaseInvoicesToBeClarified: 'Purchase invoices to be clarified',
    hasNegativeAmounts:
      'The invoice binding amount exceeds the position amount {{estimate}}. Are you sure you want to save the invoice?',
    hasMoreThenAvailableAmounts:
      'The invoice binding amount exceeds the unsettled position amount {{estimate}}. Are you sure you want to save the invoice?',
    monthFilter: 'Filter by month',
    showSettled: 'Show settled positions',
    showSpecialTeam: 'Show positions matching delivery teams',
    orderNumber: 'Order number',
    purchaseNetTotal: 'Purchase net total',
    notAssignedAmount: 'Unsettled amount',
    fillAllFields: 'Fill in all visible fields with unsettled amount',
    fillNotAssignedAmount: 'Fill with unsettled amount',
    invoiceAmountUppercase: 'INVOICE AMOUNT',
    invoiceAmount: 'Invoice amount',
    unsettledAmountUppercase: 'UNSETTLED AMOUNT',
    unsettledAmount: 'Unsettled amount',
    nip: 'VAT ID',
    invoiceNumber: 'Invoice number',
    invoiceType: 'Invoice type',
    saveAndConfirm: 'Save and confirm',
    askDeleteFvz:
      'Are you sure you want to delete the displayed purchase invoice?',
    askChangeStatus: `Are you sure you want to change the invoice status to 'Entered'?`,
    askChangeStatusWithZeroCorrection: `Note: a zero-value correction is attached to this invoice. If you are changing the campaign this invoice should be linked to, remember to manually reassign the zero correction to the new campaign as well.`,
    undoState: 'Undo state',
    saveAndStepForward: 'Save and move forward',
    stepForward: 'Move forward',
    paymentDate: 'Payment date',
    netAmount: 'Net amount',
    vatRate: 'VAT rate',
    vatAmount: 'VAT amount',
    vat: 'VAT',
    askDeletePositions:
      'Are you sure you want to delete the selected position?',
    deletePosition: 'Delete position',
    addPosition: 'Add position',
    noPositions: 'No positions',
    importFvs: 'Import FVS',
    selectFvsToImport: 'Select sales invoice to import',
    yearOfSale: 'Year of sale',
    warningDifferenceCurrencyImport:
      'When importing an invoice from a company billed in a different currency, the invoice amounts will not be imported.',
    dataImportedFromInvoice: 'Data imported from sales invoice no.',
    editFvzPosition: 'Edit purchase invoice position',
    addFvzPosition: 'Add new purchase invoice position',
    choose: 'Choose...',
    forClient: 'for biller',
    toInvoice: 'to invoice',
    sumClientAmount: 'Biller’s purchase net total',
    sumClientAmountWithoutPosition: 'Biller’s unsettled amount',
    activeProfiles: 'Active profiles',
    created: 'Created by',
    countDaysFromCreation: 'Days since creation',
    noInvoices: 'No purchase invoices',
    tvInvoices: 'TV purchase invoices',
    unsettled: 'Unsettled',
    all: 'All',
    settled: 'Entered, settled',
    generated: 'Entered',
    approvedAutomatically: 'Approved automatically',
    teamsToClarify: 'Teams to clarify',
    fvzSysNumber: 'Purchase invoice with system no.',
    editNetAmount: 'Edit purchase net total',
    purchaseNet: 'Purchase net total',
    editTotalAmount: 'Edit total amount',
    exportFvz: 'Export purchase invoices',
    invoicesDomesticToSent: 'Domestic purchase invoices (FVZ) to send',
    createInvoicesDomesticToSent:
      'Create XML with domestic purchase invoices (FVZ)',
    invoicesForeignToSent: 'Foreign purchase invoices (FVZ) to send',
    createInvoicesForeignToSent:
      'Create XML with foreign purchase invoices (FVZ)',
    invoicesDomesticToSentAgain: 'Domestic purchase invoices (FVZ) to Resend',
    createInvoicesDomesticToSentAgain:
      'Create XML with domestic purchase invoices (FVZ) that have already been sent',
    invoicesForeignToSentAgain: 'Foreign purchase invoices (FVZ) to resend',
    createInvoicesForeignToSentAgain:
      'Create XML with foreign purchase invoices (FVZ) that have already been sent',
    packagesFVZ: 'Purchase invoices (FVZ) packages',
    oldest: 'oldest',
    createCountryXML: 'Create XML with domestic invoices',
    askCreatePackage: 'Are you sure you want to create an invoice package?',
    invoicesPackage: 'XML package with invoices',
    cantDownloadPackage: 'Cannot download the package.',
    zipPackage: 'ZIP package with invoice prints',
    generatedBy: 'Generated by',
    generatedDate: 'Generation date',
    invoicesType: 'Invoice type',
    repeat: 'Sent again',
    packageCount: 'Number of invoices in the package',
    downloadPackage: 'Download XML package',
    downloadPdfs: 'Download prints',
    downloadCopies: 'Download copies',
    noPackages: 'No purchase invoice packages in the system',
    notes: 'Notes',
    general: 'Basic data',
    openNewWindow: 'Open invoice in a new window',
    sumExceedsInvoiceAmount:
      'The sum of recorded assignments exceeds the total invoice amount.',
    unwrittenUppercase: 'UNSAVED',
    invoicesInPackage:
      'Invoices included in package with system no. {{number}} from {{date}}',
    invoicingTeams: 'Invoicing teams',
    purchaseForAllTeamsFileName: 'PurchaseInvoicesToClarify',
    fullPaid: 'Purchase invoice paid',
    correctedInvoice: 'Corrected invoice',
    budgetsOfCorrectedInvoice: 'Budgets of corrected invoice',
    selectCorrectedInvoice: 'Select invoice',
    selectCorrectedInvoiceFor: 'Select corrected invoice for purchase invoice',
    number: 'number',
    date: 'dated',
    selectClientBefore: 'Select biller before',
    askDeleteOriginalInvoice:
      'Are you sure you want to delete the link to the corrected invoice?',
    deleteOriginalInvoice: 'Delete corrected invoice',
    warningSelectCorrectedInvoice:
      'Warning: you must specify and select the purchase invoice that has been corrected by the submitted document.',
    reasonForDeleteFvz: 'Reason for deleting invoice',
    automaticApproved: 'Automatically approved',
    deleteFVZ: 'Delete purchase invoice',
    requireReasonForDeleteFvz:
      'Please provide a reason for deleting the purchase invoice',
  },
  eod: {
    errorsEOD: 'EOD Errors',
    errorsFromEOD: 'Errors reported by EOD',
    importLogsToDoEOD: 'Unresolved errors during FVZ import from EOD',
    allImportLogsEOD: 'EOD FVZ import errors',
    noImportErrors: 'No import errors reported by EOD',
    noImportLogs: 'No EOD import logs',
    externalNumber: 'External number',
    errorType: 'Error type',
    eventName: 'Event name',
    details: 'Details',
    documentId: 'Document ID',
    documentExternalNumber: 'Document external number',
    documentIssueDate: 'Document issue date',
    reason: 'Reason',
    description: 'Description',
    askReimportToPOK: 'Are you sure you want to re-import the document to POK?',
    reimportToPOK: 'Re-import to POK',
    reImportToPokFinished:
      'Re-import of the document to POK has been completed.',
    reImportToPokFailed:
      'Re-import of the document to POK has failed. Refresh the page and check the information in the EOD import logs.',
    purchaseInvoiceNumber: 'Invoice number in POK',
    purchaseInvoiceSystemNumber: 'Invoice system number in POK',
    found: 'The document has been found.',
    confirmFindVZ: 'Are you sure you want to find purchase invoice?',
    findFVZ: 'Find',
    confirmRefreshErrorFromEod:
      'Are you sure you want to change the status of the exported document to allow re-import in EOD?',
    refreshErrorFromEodSuccess:
      'The document status has been changed, import it again in EOD.',
    refreshErrorFromEodFailed:
      'Cannot change the status of the exported document.',
  },
} as const;
